import { useMemo } from 'react';
import { useDelayedState } from '../../utils/hooks/useDelayedState';
const SUCCESS_DELAY = 10000;
const REVERT_DELAY = 3000;
export const useAutosaveStatus = () => {
  const [status, setStatusWithDelay] = useDelayedState('idle');
  return {
    status,
    statusHandlers: useMemo(() => ({
      savingStarted: () => {
        setStatusWithDelay('pending');
      },
      savingSucceeded: () => {
        setStatusWithDelay('success');
        setStatusWithDelay('idle', SUCCESS_DELAY);
      },
      savingReverted: () => {
        setStatusWithDelay('reverted');
        setStatusWithDelay('idle', REVERT_DELAY);
      },
      savingFailed: () => {
        setStatusWithDelay('idle');
      },
      undoStarted: () => {
        setStatusWithDelay('reverted');
        setStatusWithDelay('idle', REVERT_DELAY);
      },
      requestsCanceled: () => {
        setStatusWithDelay('reverted');
        setStatusWithDelay('idle', REVERT_DELAY);
      },
      requestsCleared: () => {
        setStatusWithDelay('idle');
      }
    }), [setStatusWithDelay])
  };
};